import React, { useEffect, useState } from 'react';
import '../App.css';
//import { Navbar, Bibliote, Footer} from '../container';
import { Header_2026, Footer_2026, Biblioteca_header_libros_2026, Biblioteca_libros_2026, Biblioteca_contacto_2026 } from '../container';

import { useTranslation } from "react-i18next";

const SecBibliote = () => {
  const [t, i18n] = useTranslation("biblioteca");

  return (
    <div className="App_DB">
      <Header_2026 />
      <div className='biblioteca-shell'>
        <Biblioteca_header_libros_2026 />
        <Biblioteca_libros_2026 />
        <Biblioteca_contacto_2026 />
      </div>

      <Footer_2026 />

    </div>
  )
}

export default SecBibliote
